import { Component, Input } from "@angular/core";

@Component({
    selector: "nx-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.scss"],
    standalone: false
})
export class DialogComponent {
  @Input() public dialogData;

  constructor() {
  }

}
